export const enMenu = [
  
  {
    id: 11,
    image: null,
    title: "KROKO MADAM",
    price: "8",
    beachMenu: false,
    beachPrice: null,
    restaurantMenu: true,
    category: "BREAKFAST",
    servingTime: { start: "9:00", end: "20:00" },
    subCategory: "",
    ingredients:
      "",
  },
  {
    id: 12,
    image: null,
    title: "MEDITERRANEAN OMELETTE",
    price: "8",
    beachMenu: false,
    beachPrice: null,
    restaurantMenu: true,
    category: "BREAKFAST",
    servingTime: { start: "9:00", end: "20:00" },
    subCategory: "",
    ingredients:
      "",
  },
  {
    id: 13,
    image: null,
    title: "ENGLISH BREAKFAST",
    price: "8",
    beachMenu: false,
    beachPrice: null,
    restaurantMenu: true,
    category: "BREAKFAST",
    servingTime: { start: "9:00", end: "20:00" },
    subCategory: "",
    ingredients:
      "",
  },
  {
    id: 14,
    image: null,
    title: "BOUGATSA WITH CREAM",
    price: "4,5",
    beachMenu: true,
    beachPrice: "4,5",
    restaurantMenu: true,
    category: "BREAKFAST",
    servingTime: { start: "9:00", end: "20:00" },
    subCategory: "",
    ingredients:
      "",
  },
  {
    id: 15,
    image: null,
    title: "BOUGATSA WITH FETA CHEESE",
    price: "4,5",
    beachMenu: true,
    beachPrice: "4,5",
    restaurantMenu: true,
    category: "BREAKFAST",
    servingTime: { start: "9:00", end: "20:00" },
    subCategory: "",
    ingredients:
      "",
  },
  {
    id: 16,
    image: null,
    title: "TOAST",
    price: "5",
    beachMenu: false,
    beachPrice: null,
    restaurantMenu: true,
    category: "BREAKFAST",
    servingTime: { start: "9:00", end: "20:00" },
    subCategory: "",
    ingredients:
      "",
  },
  {
    id: 101,
    image: null,
    title: "DAKOS",
    price: "8",
    beachMenu: false,
    beachPrice: null,
    restaurantMenu: true,
    category: "APPETIZER",
    servingTime: { start: "9:00", end: "20:00" },
    subCategory: "",
    ingredients:
      "Carob dakos with mizithra cheese, tomato, olive, grebe, oregano",
  },
  {
    id: 102,
    image: null,
    title: "ΤΖΑΤΖΙΚΙ",
    price: "5",
    category: "APPETIZER",
    servingTime: null,
    beachMenu: false,
    beachPrice: "1",
    restaurantMenu: true,
    subCategory: "",
    ingredients:
      "Traditional tzatziki with garlic & dill",
  },
{
    id: 103,
    image: null,
    title: "PIRGOS",
    price: "9",
    category: "APPETIZER",
    servingTime: null,
    beachMenu: false,
    beachPrice: "1",
    restaurantMenu: true,
    subCategory: "",
    ingredients:
      "Grilled vegetables with herb bulgur, balsamic vinaigrette, walnuts & feta mousse",
  },
{
    id: 104,
    image: null,
    title: "PUMPKIN MEATBALLS ",
    price: "7.5",
    category: "APPETIZER",
    servingTime: null,
    beachMenu: false,
    beachPrice: "1",
    restaurantMenu: true,
    subCategory: "",
    ingredients:
      "with dill & yogurt sauce",
  },
{
    id: 105,
    image: null,
    title: "GRILLED MUSHROOMS",
    price: "8",
    category: "APPETIZER",
    servingTime: null,
    beachMenu: false,
    beachPrice: "1",
    restaurantMenu: true,
    subCategory: "",
    ingredients:
      "with balsamic vinaigrette & black sesame",
  },
{
    id: 106,
    image: null,
    title: "SAGANAKI",
    price: "8",
    category: "APPETIZER",
    servingTime: null,
    beachMenu: false,
    beachPrice: "1",
    restaurantMenu: true,
    subCategory: "",
    ingredients:
      "4 cheeses & tomato jam",
  },
{
    id: 107,
    image: null,
    title: "PORTO BELLO",
    price: "8.5",
    category: "APPETIZER",
    servingTime: null,
    beachMenu: false,
    beachPrice: "1",
    restaurantMenu: true,
    subCategory: "",
    ingredients:
      "Goat cheese, bacon, hazelnut, balsamic cream",
  },
{
    id: 108,
    image: null,
    title: "HOMEMADE FRIED POTATOES",
    price: "4.5",
    category: "APPETIZER",
    servingTime: null,
    beachMenu: false,
    beachPrice: "1",
    restaurantMenu: true,
    subCategory: "",
    ingredients:
      "",
  },
{
    id: 109,
    image: null,
    title: "PHYLLO ROLLS",
    price: "7.5",
    category: "APPETIZER",
    servingTime: null,
    beachMenu: false,
    beachPrice: "1",
    restaurantMenu: true,
    subCategory: "",
    ingredients:
      "with pastrami, cheese & yogurt sauce",
  },
{
    id: 110,
    image: null,
    title: "DUSHA PALETTE",
    price: "20",
    category: "APPETIZER",
    servingTime: null,
    beachMenu: false,
    beachPrice: "1",
    restaurantMenu: true,
    subCategory: "",
    ingredients:
      "cheeses, cold cuts, fresh seasonal fruits, breadsticks, fig chutney",
  },
{
    id: 111,
    image: null,
    title: "VEGETABLE SOUP",
    price: "7.5",
    category: "APPETIZER",
    servingTime: null,
    beachMenu: false,
    beachPrice: "1",
    restaurantMenu: true,
    subCategory: "",
    ingredients:
      "with fresh seasonal vegetables",
  },
  {
    id: 112,
    image: null,
    title: "CLUB SANDWICH CHICKEN",
    price: "12.5",
    category: "APPETIZER",
    servingTime: null,
    beachMenu: true,
    beachPrice: "12,5",
    restaurantMenu: false,
    subCategory: "",
    ingredients:
      "",
  },
  {
    id: 113,
    image: null,
    title: "CLUB SANDWICH",
    price: "11.5",
    category: "APPETIZER",
    servingTime: null,
    beachMenu: true,
    beachPrice: "11,5",
    restaurantMenu: false,
    subCategory: "",
    ingredients:
      "",
  },
  {
    id: 114,
    image: null,
    title: "MINI BURGER",
    price: "12",
    category: "APPETIZER",
    servingTime: null,
    beachMenu: true,
    beachPrice: "12",
    restaurantMenu: false,
    subCategory: "",
    ingredients:
      "",
  },
  {
    id: 115,
    image: null,
    title: "TOAST",
    price: "5",
    category: "APPETIZER",
    servingTime: null,
    beachMenu: true,
    beachPrice: "5",
    restaurantMenu: false,
    subCategory: "",
    ingredients:
      "",
  },
  {
    id: 116,
    image: null,
    title: "CHICKEN WITH POTATOES",
    price: "9",
    category: "APPETIZER",
    servingTime: null,
    beachMenu: true,
    beachPrice: "9",
    restaurantMenu: false,
    subCategory: "",
    ingredients:
      "",
  },
  {
    id: 117,
    image: null,
    title: "POTATOES",
    price: "4.5",
    category: "APPETIZER",
    servingTime: null,
    beachMenu: true,
    beachPrice: "4,5",
    restaurantMenu: false,
    subCategory: "",
    ingredients:
      "",
  },
  {
    id: 118,
    image: null,
    title: "MEAT PLATTER",
    price: "75",
    category: "APPETIZER",
    servingTime: null,
    beachMenu: true,
    beachPrice: "75",
    restaurantMenu: false,
    subCategory: "",
    ingredients:
      "",
  },
{
    id: 201,
    image: null,
    title: "GREEK TRADITIONAL (VILLAGE SALAD)",
    price: "9",
    category: "SALADS",
    servingTime: null,
    beachMenu: true,
    beachPrice: "8,5",
    restaurantMenu: true,
    subCategory: "",
    ingredients:
      "Tomato, cucumber, onion, pepper, olive, feta cheese, cilantro & oregano",
  },
{
    id: 202,
    image: null,
    title: "DUSHA SALAD",
    price: "10",
    category: "SALADS",
    servingTime: null,
    beachMenu: false,
    beachPrice: "1",
    restaurantMenu: true,
    subCategory: "",
    ingredients:
"Tender lettuce leaves, cherry tomatoes, peach, balsamic vinaigrette, walnut, feta mousse & onion crackers",
  },
{
    id: 203,
    image: null,
    title: "THE HEN'S NEST",
    price: "13",
    category: "SALADS",
    servingTime: null,
    beachMenu: false,
    beachPrice: "1",
    restaurantMenu: true,
    subCategory: "",
    ingredients:
      "Iceberg, chicken fillet, corn, honey vinaigrette, parmesan flakes on a cheese nest",
  },
{
    id: 204,
    image: null,
    title: "TABOULE",
    price: "7.5",
    category: "SALADS",
    servingTime: null,
    beachMenu: false,
    beachPrice: "1",
    restaurantMenu: true,
    subCategory: "",
    ingredients:
      "Quinoa-bulgur, tomato pulp, onion, herbs, cucumber, goji berries",
  },
{
    id: 205,
    image: null,
    title: "BURATTA",
    price: "12",
    category: "SALADS",
    servingTime: null,
    beachMenu: false,
    beachPrice: "1",
    restaurantMenu: true,
    subCategory: "",
    ingredients:
      "Baby spinach, buratta mozzarella, sweet chilli, cherry tomatoes & hazelnuts",
  },
  {
    id: 206,
    image: null,
    title: "CAESAR SALAD",
    price: "8,5",
    category: "SALADS",
    servingTime: null,
    beachMenu: true,
    beachPrice: "8,5",
    restaurantMenu: false,
    subCategory: "",
    ingredients:
      "",
  },
  {
    id: 207,
    image: null,
    title: "FRUIT SALAD",
    price: "10,5",
    category: "SALADS",
    servingTime: null,
    beachMenu: true,
    beachPrice: "10,5",
    restaurantMenu: false,
    subCategory: "",
    ingredients:
      "",
  },
  {
    id: 301,
    image: null,
    title: "FRIED SQUID*",
    price: "12",
    category: "SEAFOOD",
    servingTime: null,
    beachMenu: false,
    beachPrice: "1",
    restaurantMenu: true,
    subCategory: "",
    ingredients:
      "with Seafood tartare (* Products are frozen)",
  },
{
    id: 302,
    image: null,
    title: "GRILLED OCTOPUS*",
    price: "14",
    category: "SEAFOOD",
    servingTime: null,
    beachMenu: false,
    beachPrice: "1",
    restaurantMenu: true,
    subCategory: "",
    ingredients:
      "with bulgur, tomato & fried onion (* Products are frozen)",
  },
{
    id: 303,
    image: null,
    title: "SHRIMPS*",
    price: "14",
    category: "SEAFOOD",
    servingTime: null,
    beachMenu: false,
    beachPrice: "1",
    restaurantMenu: true,
    subCategory: "",
    ingredients:
      "grilled or saganaki with fresh tomato sauce (* Products are frozen)",
  },
{
    id: 304,
    image: null,
    title: "SEA BASS",
    price: "15",
    category: "SEAFOOD",
    servingTime: null,
    beachMenu: false,
    beachPrice: "1",
    restaurantMenu: true,
    subCategory: "",
    ingredients:
      "Sea bass fillet with black vegetable rice",
  },
{
    id: 401,
    image: null,
    title: "MUSHROOM RISOTTO or BARLEY RISOTTO",
    price: "12",
    category: "PASTA / RIZOTTO",
    servingTime: null,
    beachMenu: false,
    beachPrice: "1",
    restaurantMenu: true,
    subCategory: "",
    ingredients:
      "variety of wild Portobello mushrooms, porcini, pleurotus, parmesan & truffle oil",
  },
{
    id: 402,
    image: null,
    title: "BARLEY or SEAFOOD RISOTTO",
    price: "15",
    category: "PASTA / RIZOTTO",
    servingTime: null,
    beachMenu: false,
    beachPrice: "1",
    restaurantMenu: true,
    subCategory: "",
    ingredients:
      "Shrimp, squid, octopus with pink herb sauce",
  },
{
    id: 404,
    image: null,
    title: "BARLEY VEGETARIAN",
    price: "12",
    category: "PASTA / RIZOTTO",
    servingTime: null,
    beachMenu: false,
    beachPrice: "1",
    restaurantMenu: true,
    subCategory: "",
    ingredients:
      "Mushrooms, artichoke, zucchini, peppers, sweet pumpkin & cheese mousse",
  },
{
    id: 405,
    image: null,
    title: "RIGATONI DUSHA",
    price: "12",
    category: "PASTA / RIZOTTO",
    servingTime: null,
    beachMenu: false,
    beachPrice: "1",
    restaurantMenu: true,
    subCategory: "",
    ingredients:
      "Chicken, bacon, mushrooms, cream & parmesan",
  },
{
    id: 406,
    image: null,
    title: "MEDITERRANEAN",
    price: "10",
    category: "PASTA / RIZOTTO",
    servingTime: null,
    beachMenu: false,
    beachPrice: "1",
    restaurantMenu: true,
    subCategory: "",
    ingredients:
      "Linguine, pepper, olive, bacon & garlic",
  },
{
    id: 407,
    image: null,
    title: "TAGALIATELE WITH SALMON",
    price: "15",
    category: "PASTA / RIZOTTO",
    servingTime: null,
    beachMenu: false,
    beachPrice: "1",
    restaurantMenu: true,
    subCategory: "",
    ingredients:
      "Cream, garlic, lime & chives",
  },
{
    id: 408,
    image: null,
    title: "SHRIMP* PASTA",
    price: "15",
    category: "PASTA / RIZOTTO",
    servingTime: null,
    beachMenu: false,
    beachPrice: "1",
    restaurantMenu: true,
    subCategory: "",
    ingredients:
      "Linguine, fresh tomato sauce, bisque, garlic oil  (* Products are frozen)",
  },
{
    id: 501,
    image: null,
    title: "BUTTER LINGUINE",
    price: "7",
    category: "CHILDREN'S MENU",
    servingTime: null,
    beachMenu: false,
    beachPrice: "1",
    restaurantMenu: true,
    subCategory: "",
    ingredients:
      "with fresh tomato sauce",
  },
{
    id: 502,
    image: null,
    title: "CHICKEN STICK",
    price: "9",
    category: "CHILDREN'S MENU",
    servingTime: null,
    beachMenu: false,
    beachPrice: "1",
    restaurantMenu: true,
    subCategory: "",
    ingredients:
      "Breaded chicken strips french fries, Dusha sauce",
  },
{
    id: 601,
    image: null,
    title: "STAVLISIA ",
    price: "16",
    category: "MAIN DISH",
    servingTime: null,
    beachMenu: false,
    beachPrice: "1",
    restaurantMenu: true,
    subCategory: "",
    ingredients:
      "Pork belly steak with baby potatoes",
  },
{
    id: 602,
    image: null,
    title: "BURGER DUSHA",
    price: "14",
    category: "MAIN DISH",
    servingTime: null,
    beachMenu: false,
    beachPrice: "1",
    restaurantMenu: true,
    subCategory: "",
    ingredients:
      "100% beef burger with egg, cheese, bacon, caramelized onion BBQ sauce and fresh fried potatoes",
  },
{
    id: 603,
    image: null,
    title: "CHICKEN FILLET",
    price: "11",
    category: "MAIN DISH",
    servingTime: null,
    beachMenu: false,
    beachPrice: "1",
    restaurantMenu: true,
    subCategory: "",
    ingredients:
      "grilled or schnitzel with mashed potatoes & Dijon",
  },
{
    id: 604,
    image: null,
    title: "CHICKEN FILLET",
    price: "14",
    category: "MAIN DISH",
    servingTime: null,
    beachMenu: false,
    beachPrice: "1",
    restaurantMenu: true,
    subCategory: "",
    ingredients:
      "caramelized pancetta with sweet potato puree & roast sauce",
  },
{
    id: 605,
    image: null,
    title: "SWEET-SOUR",
    price: "12",
    category: "MAIN DISH",
    servingTime: null,
    beachMenu: false,
    beachPrice: "1",
    restaurantMenu: true,
    subCategory: "",
    ingredients:
      "chicken, fried rice, julienne vegetables, sweet and sour sauce & black sesame",
  },
{
    id: 606,
    image: null,
    title: "BIG SOUVLAKI PORK",
    price: "12",
    category: "MAIN DISH",
    servingTime: null,
    beachMenu: false,
    beachPrice: "1",
    restaurantMenu: true,
    subCategory: "",
    ingredients:
      "with fresh potatoes, pita and herbs",
  },
{
    id: 607,
    image: null,
    title: "BIG SOUVLAKI CHICKEN",
    price: "12",
    category: "MAIN DISH",
    servingTime: null,
    beachMenu: false,
    beachPrice: "1",
    restaurantMenu: true,
    subCategory: "",
    ingredients:
      "chicken leg, pita, new potato and dijon",
  },
  {
    id: 701,
    image: null,
    title: "LAMB RIBS",
    price: "22",
    category: "PREMIUM MEAT CUTS",
    servingTime: null,
    beachMenu: false,
    beachPrice: "1",
    restaurantMenu: true,
    subCategory: "",
    ingredients:
      "In premium dishes, garnishes are charged extra",
  },
  {
    id: 702,
    image: null,
    title: "RIBEYE",
    price: "32",
    category: "PREMIUM MEAT CUTS",
    servingTime: null,
    beachMenu: false,
    beachPrice: "1",
    restaurantMenu: true,
    subCategory: "",
    ingredients:
      "In premium dishes, garnishes are charged extra",
  },
{
    id: 801,
    image: null,
    title: "GRECO",
    price: "16",
    category: "PIZZA",
    servingTime: null,
    beachMenu: true,
    beachPrice: "16",
    restaurantMenu: true,
    subCategory: "",
    ingredients:
      "spinach, olives, feta cheese, cherry tomatoes,  topped with fresh tomato sauce and gouda cheese",
  },
{
    id: 802,
    image: null,
    title: "BELLA ITALIA",
    price: "18",
    category: "PIZZA",
    servingTime: null,
    beachMenu: true,
    beachPrice: "18",
    restaurantMenu: true,
    subCategory: "",
    ingredients:
      "mozzarella, cherry tomatoes, serrano prosciutto, basil leavess,  topped with fresh tomato sauce and gouda cheese",
  },
{
    id: 803,
    image: null,
    title: "DUSHA",
    price: "18",
    category: "PIZZA",
    servingTime: null,
    beachMenu: true,
    beachPrice: "18",
    restaurantMenu: true,
    subCategory: "",
    ingredients:
      "broccoli, chicken fillet, hollandaise sauces,  topped with fresh tomato sauce and gouda cheese",
  },
{
    id: 804,
    image: null,
    title: "PIZZA GYROS",
    price: "18",
    category: "PIZZA",
    servingTime: null,
    beachMenu: true,
    beachPrice: "18",
    restaurantMenu: true,
    subCategory: "",
    ingredients:
      "tomato, onions",
  },
{
    id: 805,
    image: null,
    title: "QUATTRO FORMAGGIE",
    price: "16",
    category: "PIZZA",
    servingTime: null,
    beachMenu: true,
    beachPrice: "16",
    restaurantMenu: true,
    subCategory: "",
    ingredients:
      "Four cheesess,  topped with fresh tomato sauce and gouda cheese",
  },
{
    id: 806,
    image: null,
    title: "SPECIAL",
    price: "16",
    category: "PIZZA",
    servingTime: null,
    beachMenu: true,
    beachPrice: "16",
    restaurantMenu: true,
    subCategory: "",
    ingredients:
      "ham, mushrooms, peppers,  topped with fresh tomato sauce and gouda cheese",
  },
{
    id: 807,
    image: null,
    title: "MARGARITA",
    price: "12",
    category: "PIZZA",
    servingTime: null,
    beachMenu: true,
    beachPrice: "12",
    restaurantMenu: true,
    subCategory: "",
    ingredients:
      "with mozzarellas,  topped with fresh tomato sauce and gouda cheese",
  },
{
    id: 808,
    image: null,
    title: "PEPERONI",
    price: "14",
    category: "PIZZA",
    servingTime: null,
    beachMenu: true,
    beachPrice: "14",
    restaurantMenu: true,
    subCategory: "",
    ingredients:
      "with salamis,  topped with fresh tomato sauce and gouda cheese",
  },
  {
    id: 809,
    image: null,
    title: "CHICKEN PIZZA ROLL",
    price: "9,5",
    category: "PIZZA",
    servingTime: null,
    beachMenu: true,
    beachPrice: "9,5",
    restaurantMenu: false,
    subCategory: "",
    ingredients:
      "",
  },
  {
    id: 810,
    image: null,
    title: "MOZZARELLA PIZZA ROLL",
    price: "9,5",
    category: "PIZZA",
    servingTime: null,
    beachMenu: true,
    beachPrice: "9,5",
    restaurantMenu: false,
    subCategory: "",
    ingredients:
      "",
  },
  {
    id: 811,
    image: null,
    title: "PROSCIUTTO PIZZA ROLL",
    price: "9,5",
    category: "PIZZA",
    servingTime: null,
    beachMenu: true,
    beachPrice: "9,5",
    restaurantMenu: false,
    subCategory: "",
    ingredients:
      "",
  },
{
    id: 901,
    image: null,
    title: "CHOCOLATE SOUFFLE",
    price: "8",
    category: "DESSERTS",
    servingTime: null,
    beachMenu: false,
    beachPrice: "1",
    restaurantMenu: true,
    subCategory: "",
    ingredients:
      "with vanilla ice cream",
  },
{
    id: 902,
    image: null,
    title: "TART",
    price: "7",
    category: "DESSERTS",
    servingTime: null,
    beachMenu: false,
    beachPrice: "1",
    restaurantMenu: true,
    subCategory: "",
    ingredients:
      "with fresh seasonal fruits",
  },
{
    id: 903,
    image: null,
    title: "PROFITEROLL",
    price: "8",
    category: "DESSERTS",
    servingTime: null,
    beachMenu: false,
    beachPrice: "1",
    restaurantMenu: true,
    subCategory: "",
    ingredients:
      "with whipped cream and almond fillets",
  },
{
    id: 904,
    image: null,
    title: "MILFAGE",
    price: "7",
    category: "DESSERTS",
    servingTime: null,
    beachMenu: false,
    beachPrice: "1",
    restaurantMenu: true,
    subCategory: "",
    ingredients:
      "with pastry cream",
  },
  {
    id: 905,
    image: null,
    title: "ICE CREAM ONE SCOOP",
    price: "2,5",
    category: "DESSERTS",
    servingTime: null,
    beachMenu: true,
    beachPrice: "2,5",
    restaurantMenu: false,
    subCategory: "",
    ingredients:
      "",
  },
{
    id: 906,
    image: null,
    title: "ICE CREAM SORBET MANGO",
    price: "5",
    category: "DESSERTS",
    servingTime: null,
    beachMenu: true,
    beachPrice: "6",
    restaurantMenu: true,
    subCategory: "",
    ingredients:
      "",
  },
{
    id: 907,
    image: null,
    title: "ICE CREAM COOKIES PRALINE",
    price: "5",
    category: "DESSERTS",
    servingTime: null,
    beachMenu: true,
    beachPrice: "6",
    restaurantMenu: true,
    subCategory: "",
    ingredients:
      "",
  },
{
    id: 908,
    image: null,
    title: "ICE CREAM COOKIE DOUGH VANILLA MADAGASCAR",
    price: "5",
    category: "DESSERTS",
    servingTime: null,
    beachMenu: true,
    beachPrice: "6",
    restaurantMenu: true,
    subCategory: "",
    ingredients:
      "",
  },
{
    id: 909,
    image: null,
    title: "ICE CREAM YOGURT FRUITS NUTS",
    price: "5",
    category: "DESSERTS",
    servingTime: null,
    beachMenu: true,
    beachPrice: "6",
    restaurantMenu: true,
    subCategory: "",
    ingredients:
      "",
  },
  {
    id: 910,
    image: null,
    title: "ICE CREAM RICOTTA PISTACHIO RED VELVET CRUMBLE",
    price: "5",
    category: "DESSERTS",
    servingTime: null,
    beachMenu: true,
    beachPrice: "6",
    restaurantMenu: true,
    subCategory: "",
    ingredients:
      "",
  },
  {
    id: 911,
    image: null,
    title: "ICE CREAM CHOCOLATE BROWNIES CHUNKS",
    price: "5",
    category: "DESSERTS",
    servingTime: null,
    beachMenu: true,
    beachPrice: "6",
    restaurantMenu: true,
    subCategory: "",
    ingredients:
      "",
  },
  {
    id: 912,
    image: null,
    title: "ICE CREAM GIANDUJA CHOCO BALLS",
    price: "5",
    category: "DESSERTS",
    servingTime: null,
    beachMenu: true,
    beachPrice: "6",
    restaurantMenu: true,
    subCategory: "",
    ingredients:
      "",
  },
  {
    id: 1301,
    image: null,
    title: "Espresso",
    price: "3",
    category: "COFFEE",
    servingTime: null,
    beachMenu: true,
    beachPrice: "7",
    restaurantMenu: true,
    subCategory: "",
    ingredients: "",
  },
  {
    id: 1302,
    image: null,
    title: "Double espresso",
    price: "3,5",
    category: "COFFEE",
    servingTime: null,
    beachMenu: true,
    beachPrice: "7",
    restaurantMenu: true,
    subCategory: "",
    ingredients: "",
  },
  {
    id: 1303,
    image: null,
    title: "Freddo espresso",
    price: "4",
    category: "COFFEE",
    servingTime: null,
    beachMenu: true,
    beachPrice: "7",
    restaurantMenu: true,
    subCategory: "",
    ingredients: "",
  },
  {
    id: 1304,
    image: null,
    title: "Freddo cappuccino",
    price: "4,5",
    category: "COFFEE",
    servingTime: null,
    beachMenu: true,
    beachPrice: "7",
    restaurantMenu: true,
    subCategory: "",
    ingredients: "",
  },
  {
    id: 1305,
    image: null,
    title: "Frappe",
    price: "3,5",
    category: "COFFEE",
    servingTime: null,
    beachMenu: true,
    beachPrice: "7",
    restaurantMenu: true,
    subCategory: "",
    ingredients: "",
  },
  {
    id: 1306,
    image: null,
    title: "Greek coffee single",
    price: "2,5",
    category: "COFFEE",
    servingTime: null,
    beachMenu: true,
    beachPrice: "7",
    restaurantMenu: true,
    subCategory: "",
    ingredients: "",
  },
  {
    id: 1307,
    image: null,
    title: "Greek coffee double",
    price: "3,5",
    category: "COFFEE",
    servingTime: null,
    beachMenu: true,
    beachPrice: "7",
    restaurantMenu: true,
    subCategory: "",
    ingredients: "",
  },
  {
    id: 1308,
    image: null,
    title: "Cappuccino single",
    price: "3,5",
    category: "COFFEE",
    servingTime: null,
    beachMenu: true,
    beachPrice: "7",
    restaurantMenu: true,
    subCategory: "",
    ingredients: "",
  },
  {
    id: 1309,
    image: null,
    title: "Cappuccino double",
    price: "4,5",
    category: "COFFEE",
    servingTime: null,
    beachMenu: true,
    beachPrice: "7",
    restaurantMenu: true,
    subCategory: "",
    ingredients: "",
  },
  {
    id: 1310,
    image: null,
    title: "Latte",
    price: "4",
    category: "COFFEE",
    servingTime: null,
    beachMenu: true,
    beachPrice: "7",
    restaurantMenu: true,
    subCategory: "",
    ingredients: "",
  },
  {
    id: 1311,
    image: null,
    title: "Americano",
    price: "3,5",
    category: "COFFEE",
    servingTime: null,
    beachMenu: true,
    beachPrice: "7",
    restaurantMenu: true,
    subCategory: "",
    ingredients: "",
  },
  {
    id: 1312,
    image: null,
    title: "Hot chocolate",
    price: "4,5",
    category: "COFFEE",
    servingTime: null,
    beachMenu: true,
    beachPrice: "7",
    restaurantMenu: true,
    subCategory: "",
    ingredients: "",
  },
  {
    id: 1313,
    image: null,
    title: "Iced chocolate",
    price: "4,5",
    category: "COFFEE",
    servingTime: null,
    beachMenu: true,
    beachPrice: "7",
    restaurantMenu: true,
    subCategory: "",
    ingredients: "",
  },
  {
    id: 1314,
    image: null,
    title: "Filter coffee",
    price: "3,5",
    category: "COFFEE",
    servingTime: null,
    beachMenu: true,
    beachPrice: "7",
    restaurantMenu: true,
    subCategory: "",
    ingredients: "",
  },
  {
    id: 1315,
    image: null,
    title: "Macchiato",
    price: "7",
    category: "COFFEE",
    servingTime: null,
    beachMenu: true,
    beachPrice: "7",
    restaurantMenu: false,
    subCategory: "",
    ingredients: "",
  },
  {
    id: 1316,
    image: null,
    title: "Coffee with Ice Cream ",
    price: "8,5",
    category: "COFFEE",
    servingTime: null,
    beachMenu: true,
    beachPrice: "8,5",
    restaurantMenu: false,
    subCategory: "",
    ingredients: "",
  },
  {
    id: 1401,
    image: null,
    title: "Orange",
    price: "4",
    category: "JUICES",
    servingTime: null,
    beachMenu: true,
    beachPrice: "7",
    restaurantMenu: true,
    subCategory: "",
    ingredients: "",
  },
  {
    id: 1402,
    image: null,
    title: "Sour cherry",
    price: "4",
    category: "JUICES",
    servingTime: null,
    beachMenu: true,
    beachPrice: "7",
    restaurantMenu: true,
    subCategory: "",
    ingredients: "",
  },
  {
    id: 1403,
    image: null,
    title: "Apple",
    price: "4",
    category: "JUICES",
    servingTime: null,
    beachMenu: true,
    beachPrice: "7",
    restaurantMenu: true,
    subCategory: "",
    ingredients: "",
  },
  {
    id: 1404,
    image: null,
    title: "Pineapple",
    price: "4",
    category: "JUICES",
    servingTime: null,
    beachMenu: true,
    beachPrice: "7",
    restaurantMenu: true,
    subCategory: "",
    ingredients: "",
  },
  {
    id: 1405,
    image: null,
    title: "Peach",
    price: "4",
    category: "JUICES",
    servingTime: null,
    beachMenu: true,
    beachPrice: "7",
    restaurantMenu: true,
    subCategory: "",
    ingredients: "",
  },
  {
    id: 1406,
    image: null,
    title: "Banana",
    price: "4",
    category: "JUICES",
    servingTime: null,
    beachMenu: true,
    beachPrice: "7",
    restaurantMenu: true,
    subCategory: "",
    ingredients: "",
  },
  {
    id: 1407,
    image: null,
    title: "Mixed",
    price: "4",
    category: "JUICES",
    servingTime: null,
    beachMenu: true,
    beachPrice: "7",
    restaurantMenu: true,
    subCategory: "",
    ingredients: "",
  },
  {
    id: 1501,
    image: null,
    title: "Homemade lemonade",
    price: "4",
    category: "LEMONADES",
    servingTime: null,
    beachMenu: true,
    beachPrice: "7",
    restaurantMenu: true,
    subCategory: "",
    ingredients: "",
  },
  {
    id: 1502,
    image: null,
    title: "Strawberry lemonade",
    price: "4",
    category: "LEMONADES",
    servingTime: null,
    beachMenu: true,
    beachPrice: "7",
    restaurantMenu: true,
    subCategory: "",
    ingredients: "",
  },
  {
    id: 1503,
    image: null,
    title: "Sour cherry",
    price: "4",
    category: "LEMONADES",
    servingTime: null,
    beachMenu: false,
    beachPrice: null,
    restaurantMenu: true,
    subCategory: "",
    ingredients: "",
  },
  {
    id: 1504,
    image: null,
    title: "Granita Strawberry",
    price: "5",
    category: "LEMONADES",
    servingTime: null,
    beachMenu: true,
    beachPrice: "7",
    restaurantMenu: true,
    subCategory: "",
    ingredients: "",
  },
  {
    id: 1505,
    image: null,
    title: "Granita Lemon",
    price: "5",
    category: "LEMONADES",
    servingTime: null,
    beachMenu: true,
    beachPrice: "7",
    restaurantMenu: true,
    subCategory: "",
    ingredients: "",
  },
  {
    id: 1506,
    image: null,
    title: "Granita Mix",
    price: "5",
    category: "LEMONADES",
    servingTime: null,
    beachMenu: true,
    beachPrice: "7",
    restaurantMenu: true,
    subCategory: "",
    ingredients: "",
  },
  {
    id: 1601,
    image: null,
    title: "Aperol spritz",
    price: "10",
    category: "COCKTAILS",
    servingTime: null,
    beachMenu: true,
    beachPrice: "10",
    restaurantMenu: true,
    subCategory: "",
    ingredients: "Aperol bitter, prosecco, soda orange bitter",
  },
  {
    id: 1602,
    image: null,
    title: "Mojito",
    price: "11",
    category: "COCKTAILS",
    servingTime: null,
    beachMenu: true,
    beachPrice: "11",
    restaurantMenu: true,
    subCategory: "",
    ingredients:
      "Blanco rum, fresh lime, Caster sugar, fresh peppermint (flavours+1€)",
  },
  {
    id: 1603,
    image: null,
    title: "Margarita",
    price: "11",
    category: "COCKTAILS",
    servingTime: null,
    beachMenu: true,
    beachPrice: "11",
    restaurantMenu: true,
    subCategory: "",
    ingredients: "Premium bianco tequila, orange liqueur, fresh lime",
  },
  {
    id: 1604,
    image: null,
    title: "Cosmopolitan",
    price: "12",
    category: "COCKTAILS",
    servingTime: null,
    beachMenu: true,
    beachPrice: "12",
    restaurantMenu: true,
    subCategory: "",
    ingredients: "Citroen vodka, orange liqueur, fresh lime, cranberry juice",
  },
  {
    id: 1605,
    image: null,
    title: "Gin mule",
    price: "12",
    category: "COCKTAILS",
    servingTime: null,
    beachMenu: true,
    beachPrice: "12",
    restaurantMenu: true,
    subCategory: "",
    ingredients: "Dry gin, apple liqueur, fresh lime, gingerbeer",
  },
  {
    id: 1606,
    image: null,
    title: "Cherry blossom",
    price: "10",
    category: "COCKTAILS",
    servingTime: null,
    beachMenu: true,
    beachPrice: "10",
    restaurantMenu: true,
    subCategory: "",
    ingredients: "Blanco vermouth, cherry soda fresh berries & peppermint",
  },
  {
    id: 1607,
    image: null,
    title: "Passion martini",
    price: "12",
    category: "COCKTAILS",
    servingTime: null,
    beachMenu: true,
    beachPrice: "12",
    restaurantMenu: true,
    subCategory: "",
    ingredients: "Vodka vanilla, Passion liqueur, lime, sugar & fresh Passion",
  },
  {
    id: 1608,
    image: null,
    title: "Paloma",
    price: "11",
    category: "COCKTAILS",
    servingTime: null,
    beachMenu: true,
    beachPrice: "11",
    restaurantMenu: true,
    subCategory: "",
    ingredients: "Blanco tequila, fresh lime, grapefruit soda",
  },
  {
    id: 1609,
    image: null,
    title: "Mai-tai",
    price: "13",
    category: "COCKTAILS",
    servingTime: null,
    beachMenu: true,
    beachPrice: "13",
    restaurantMenu: true,
    subCategory: "",
    ingredients:
      "Jamaica blend rum, orange Curacao, almond syrup, fresh lime mix bitter",
  },
  {
    id: 1610,
    image: null,
    title: "Dusha royale",
    price: "14",
    category: "COCKTAILS",
    servingTime: null,
    beachMenu: true,
    beachPrice: "14",
    restaurantMenu: true,
    subCategory: "",
    ingredients: "Aperitivo pergamonti, champagne, Green olives",
  },
  {
    id: 1701,
    image: null,
    title: " Georgiadis Estate - Marble King",
    price: "20",
    category: "WINE LIST",
    servingTime: null,
    beachMenu: false,
    beachPrice: null,
    restaurantMenu: true,
    subCategory: "WHITE WINE",
    ingredients: "Rodite-malagouzia",
  },
  {
    id: 1702,
    image: null,
    title: "Constantara Estate",
    price: "22",
    category: "WINE LIST",
    servingTime: null,
    beachMenu: false,
    beachPrice: null,
    restaurantMenu: true,
    subCategory: "WHITE WINE",
    ingredients: "Sauvignon blanc",
  },
  {
    id: 1703,
    image: null,
    title: "Bosinakis Mantineia",
    price: "23",
    category: "WINE LIST",
    servingTime: null,
    beachMenu: false,
    beachPrice: null,
    restaurantMenu: true,
    subCategory: "WHITE WINE",
    ingredients: "Moschofilero",
  },
  {
    id: 1704,
    image: null,
    title: "Iatridis estate",
    price: "32",
    category: "WINE LIST",
    servingTime: null,
    beachMenu: false,
    beachPrice: null,
    restaurantMenu: true,
    subCategory: "WHITE WINE",
    ingredients: "Malagouzia",
  },
  {
    id: 1705,
    image: null,
    title: "Iatridis estate",
    price: "36",
    category: "WINE LIST",
    servingTime: null,
    beachMenu: false,
    beachPrice: null,
    restaurantMenu: true,
    subCategory: "WHITE WINE",
    ingredients: "Assyrian",
  },
  {
    id: 1706,
    image: null,
    title: "Alpha estate",
    price: "38",
    category: "WINE LIST",
    servingTime: null,
    beachMenu: false,
    beachPrice: null,
    restaurantMenu: true,
    subCategory: "WHITE WINE",
    ingredients: "Chardonnay",
  },
  {
    id: 1707,
    image: null,
    title: "Dark estate",
    price: "35",
    category: "WINE LIST",
    servingTime: null,
    beachMenu: false,
    beachPrice: null,
    restaurantMenu: true,
    subCategory: "WHITE WINE",
    ingredients: "Viognier",
  },
  {
    id: 1708,
    image: null,
    title: "Estate books country - Ovilos",
    price: "55",
    category: "WINE LIST",
    servingTime: null,
    beachMenu: false,
    beachPrice: null,
    restaurantMenu: true,
    subCategory: "WHITE WINE",
    ingredients: "Semillon-Assyrian",
  },
  {
    id: 1709,
    image: null,
    title: " Gavala Estate - Santorini",
    price: "65",
    category: "WINE LIST",
    servingTime: null,
    beachMenu: false,
    beachPrice: null,
    restaurantMenu: true,
    subCategory: "WHITE WINE",
    ingredients: "Assyrian",
  },
  {
    id: 1710,
    image: null,
    title: "Domaine William - Fevre Chablis",
    price: "62",
    category: "WINE LIST",
    servingTime: null,
    beachMenu: false,
    beachPrice: null,
    restaurantMenu: true,
    subCategory: "WHITE WINE",
    ingredients: "Chardonnay",
  },
  {
    id: 1801,
    image: null,
    title: "Pasqua mater Anna",
    price: "22",
    category: "WINE LIST",
    servingTime: null,
    beachMenu: false,
    beachPrice: null,
    restaurantMenu: true,
    subCategory: "ROSE WINE",
    ingredients: "Pinot grigio",
  },
  {
    id: 1802,
    image: null,
    title: "Dryopi estate",
    price: "23",
    category: "WINE LIST",
    servingTime: null,
    beachMenu: false,
    beachPrice: null,
    restaurantMenu: true,
    subCategory: "ROSE WINE",
    ingredients: "Agiorgitiko",
  },
  {
    id: 1803,
    image: null,
    title: "Mylona Estate",
    price: "30",
    category: "WINE LIST",
    servingTime: null,
    beachMenu: false,
    beachPrice: null,
    restaurantMenu: true,
    subCategory: "ROSE WINE",
    ingredients: "Malagouzia - Mandilaria",
  },
  {
    id: 1804,
    image: null,
    title: "Iatridis Estate - Ampelourgos",
    price: "32",
    category: "WINE LIST",
    servingTime: null,
    beachMenu: false,
    beachPrice: null,
    restaurantMenu: true,
    subCategory: "ROSE WINE",
    ingredients: "Assyrtiko -xinomavro",
  },
  {
    id: 1805,
    image: null,
    title: "Estate books country",
    price: "35",
    category: "WINE LIST",
    servingTime: null,
    beachMenu: false,
    beachPrice: null,
    restaurantMenu: true,
    subCategory: "ROSE WINE",
    ingredients: "Syrah",
  },
  {
    id: 1806,
    image: null,
    title: "Oin. Grilemis",
    price: "38",
    category: "WINE LIST",
    servingTime: null,
    beachMenu: false,
    beachPrice: null,
    restaurantMenu: true,
    subCategory: "ROSE WINE",
    ingredients: "Lake",
  },
  {
    id: 1807,
    image: null,
    title: "Estate la tour melas - Idylle d Achinos",
    price: "45",
    category: "WINE LIST",
    servingTime: null,
    beachMenu: false,
    beachPrice: null,
    restaurantMenu: true,
    subCategory: "ROSE WINE",
    ingredients: "Agiortiko-grenache Rouge-syrah",
  },
  {
    id: 1808,
    image: null,
    title: "Lazaridis Estate",
    price: "38",
    category: "WINE LIST",
    servingTime: null,
    beachMenu: false,
    beachPrice: null,
    restaurantMenu: true,
    subCategory: "ROSE WINE",
    ingredients: "Merlot",
  },
  {
    id: 1809,
    image: null,
    title: "Miraval",
    price: "52",
    category: "WINE LIST",
    servingTime: null,
    beachMenu: false,
    beachPrice: null,
    restaurantMenu: true,
    subCategory: "ROSE WINE",
    ingredients: "Cinsault-grenache rouge-syrah-rolle",
  },
  {
    id: 1901,
    image: null,
    title: "Butari Naoussa",
    price: "28",
    category: "WINE LIST",
    servingTime: null,
    beachMenu: false,
    beachPrice: null,
    restaurantMenu: true,
    subCategory: "RED WINE",
    ingredients: "Xinomavro",
  },
  {
    id: 1902,
    image: null,
    title: " Hotel Aivali Nemea",
    price: "32",
    category: "WINE LIST",
    servingTime: null,
    beachMenu: false,
    beachPrice: null,
    restaurantMenu: true,
    subCategory: "RED WINE",
    ingredients: "Agiorgitiko",
  },
  {
    id: 1903,
    image: null,
    title: "Estate art of wine Art of alipia",
    price: "32",
    category: "WINE LIST",
    servingTime: null,
    beachMenu: false,
    beachPrice: null,
    restaurantMenu: true,
    subCategory: "RED WINE",
    ingredients: "Cabernet sauvignon Agiorgitiko",
  },
  {
    id: 1904,
    image: null,
    title: "Estate Iatridis",
    price: "38",
    category: "WINE LIST",
    servingTime: null,
    beachMenu: false,
    beachPrice: null,
    restaurantMenu: true,
    subCategory: "RED WINE",
    ingredients: "Syrah-black crisp",
  },
  {
    id: 1905,
    image: null,
    title: "Thymiopoulos Earth & Sky",
    price: "46",
    category: "WINE LIST",
    servingTime: null,
    beachMenu: false,
    beachPrice: null,
    restaurantMenu: true,
    subCategory: "RED WINE",
    ingredients: "Xinomavro",
  },
  {
    id: 1906,
    image: null,
    title: " Bottle of wine (R)",
    price: "52",
    category: "WINE LIST",
    servingTime: null,
    beachMenu: false,
    beachPrice: null,
    restaurantMenu: true,
    subCategory: "RED WINE",
    ingredients: "Merlot-syrah-xinomavro",
  },
  {
    id: 1907,
    image: null,
    title: "Bottle of Wine",
    price: "40",
    category: "WINE LIST",
    servingTime: null,
    beachMenu: true,
    beachPrice: "40",
    restaurantMenu: false,
    subCategory: "RED WINE",
    ingredients: "",
  },
    {
    id: 1908,
    image: null,
    title: "Bottle of Wine Premium",
    price: "60",
    category: "WINE LIST",
    servingTime: null,
    beachMenu: true,
    beachPrice: "60",
    restaurantMenu: false,
    subCategory: "RED WINE",
    ingredients: "",
  },
  {
    id: 2001,
    image: null,
    title: "Asolo 57 Prosecco Monteliana",
    price: "32",
    category: "WINE LIST",
    servingTime: null,
    beachMenu: true,
    beachPrice: "45",
    restaurantMenu: true,
    subCategory: "SPARKLING",
    ingredients: "Glera",
  },
  {
    id: 2002,
    image: null,
    title: "Prosecco Monteliana rosé",
    price: "30",
    category: "WINE LIST",
    servingTime: null,
    beachMenu: true,
    beachPrice: "45",
    restaurantMenu: true,
    subCategory: "SPARKLING",
    ingredients: "Glera-pinot noir",
  },
  {
    id: 2003,
    image: null,
    title: "Moscato Dasti Sollicelo",
    price: "30",
    category: "WINE LIST",
    servingTime: null,
    beachMenu: false,
    beachPrice: null,
    restaurantMenu: true,
    subCategory: "SPARKLING",
    ingredients: "Moscato Bianco",
  },
  {
    id: 2004,
    image: null,
    title: "Asti martini",
    price: "30",
    category: "WINE LIST",
    servingTime: null,
    beachMenu: false,
    beachPrice: null,
    restaurantMenu: true,
    subCategory: "SPARKLING",
    ingredients: "Moscato",
  },
  {
    id: 2101,
    image: null,
    title: "Moët chandon Brut imperial",
    price: "120",
    category: "WINE LIST",
    servingTime: null,
    beachMenu: true,
    beachPrice: "120",
    restaurantMenu: true,
    subCategory: "CHAMPAGNE",
    ingredients: "Chardonnay-pinot noir Pinot menier",
  },
  {
    id: 2102,
    image: null,
    title: "Moët ice Demi-sec",
    price: "150",
    category: "WINE LIST",
    servingTime: null,
    beachMenu: true,
    beachPrice: "150",
    restaurantMenu: true,
    subCategory: "CHAMPAGNE",
    ingredients: "Chardonnay-pinot noir Pinot menier",
  },
  {
    id: 2103,
    image: null,
    title: "Laurent Perrier La cuvee brut",
    price: "120",
    category: "WINE LIST",
    servingTime: null,
    beachMenu: true,
    beachPrice: "120",
    restaurantMenu: true,
    subCategory: "CHAMPAGNE",
    ingredients: "Chardonnay-pinot noir Pinot menier",
  },
  {
    id: 2201,
    image: null,
    title: "Moët chandon",
    price: "120",
    category: "WINE LIST",
    servingTime: null,
    beachMenu: true,
    beachPrice: "120",
    restaurantMenu: true,
    subCategory: "CHAMPAGNE ROSE",
    ingredients: "Chardonnay-pinot noir Pinot menier",
  },
  {
    id: 2202,
    image: null,
    title: " Moët ice Demi-sec",
    price: "150",
    category: "WINE LIST",
    servingTime: null,
    beachMenu: true,
    beachPrice: "150",
    restaurantMenu: true,
    subCategory: "CHAMPAGNE ROSE",
    ingredients: "Chardonnay-pinot noir Pinot menier",
  },
  {
    id: 2203,
    image: null,
    title: "Laurent Perrier",
    price: "180",
    category: "WINE LIST",
    servingTime: null,
    beachMenu: true,
    beachPrice: "180",
    restaurantMenu: true,
    subCategory: "CHAMPAGNE ROSE",
    ingredients: "Pinot noir",
  },
  {
    id: 2204,
    image: null,
    title: "Dom Pérignon",
    price: "380",
    category: "WINE LIST",
    servingTime: null,
    beachMenu: true,
    beachPrice: "380",
    restaurantMenu: true,
    subCategory: "CHAMPAGNE ROSE",
    ingredients: "",
  },
  {
    id: 2301,
    image: null,
    title: " White dry-semi-sweet Julia wine",
    price: "7",
    category: "DRINKS",
    servingTime: null,
    beachMenu: false,
    beachPrice: null,
    restaurantMenu: true,
    subCategory: "",
    ingredients: "500ml",
  },
  {
    id: 2302,
    image: null,
    title: " Pink dry-semi-sweet Julia wine",
    price: "7",
    category: "DRINKS",
    servingTime: null,
    beachMenu: false,
    beachPrice: null,
    restaurantMenu: true,
    subCategory: "",
    ingredients: "500ml",
  },
  {
    id: 2303,
    image: null,
    title: "Red dry-semi-sweet Julia wine",
    price: "7",
    category: "DRINKS",
    servingTime: null,
    beachMenu: false,
    beachPrice: null,
    restaurantMenu: true,
    subCategory: "",
    ingredients: "500ml",
  },
  {
    id: 2304,
    image: null,
    title: "Retsina Julia",
    price: "6",
    category: "DRINKS",
    servingTime: null,
    beachMenu: false,
    beachPrice: null,
    restaurantMenu: true,
    subCategory: "",
    ingredients: "500ml ",
  },
  {
    id: 2305,
    image: null,
    title: "Retsina Vassiliki",
    price: "6",
    category: "DRINKS",
    servingTime: null,
    beachMenu: false,
    beachPrice: null,
    restaurantMenu: true,
    subCategory: "",
    ingredients: "500ml",
  },
  {
    id: 2306,
    image: null,
    title: "Ouzo Plomari",
    price: "8",
    category: "DRINKS",
    servingTime: null,
    beachMenu: false,
    beachPrice: null,
    restaurantMenu: true,
    subCategory: "",
    ingredients: "200ml",
  },
  {
    id: 2307,
    image: null,
    title: "Ouzo Varvagiannis",
    price: "9",
    category: "DRINKS",
    servingTime: null,
    beachMenu: false,
    beachPrice: null,
    restaurantMenu: true,
    subCategory: "",
    ingredients: "200ml",
  },
  {
    id: 2308,
    image: null,
    title: "Tsipouro Apostolakis",
    price: "9,5",
    category: "DRINKS",
    servingTime: null,
    beachMenu: false,
    beachPrice: null,
    restaurantMenu: true,
    subCategory: "",
    ingredients: "200ml",
  },
  {
    id: 2309,
    image: null,
    title: "Tsipouro Voluptuous",
    price: "9,5",
    category: "DRINKS",
    servingTime: null,
    beachMenu: false,
    beachPrice: null,
    restaurantMenu: true,
    subCategory: "",
    ingredients: "200ml",
  },
  {
    id: 2317,
    image: null,
    title: "Soft drinks",
    price: "3",
    category: "DRINKS",
    servingTime: null,
    beachMenu: true,
    beachPrice: "7",
    restaurantMenu: true,
    subCategory: "",
    ingredients: "250ml",
  },
  {
    id: 2319,
    image: null,
    title: "Ice Tea",
    price: "6",
    category: "DRINKS",
    servingTime: null,
    beachMenu: true,
    beachPrice: "7",
    restaurantMenu: false,
    subCategory: "",
    ingredients: "",
  },
  {
    id: 2320,
    image: null,
    title: "Spirits Simple",
    price: "8",
    category: "DRINKS",
    servingTime: null,
    beachMenu: true,
    beachPrice: "8",
    restaurantMenu: false,
    subCategory: "",
    ingredients: "glass",
  },
  {
    id: 2321,
    image: null,
    title: "Spirits Simple",
    price: "80",
    category: "DRINKS",
    servingTime: null,
    beachMenu: true,
    beachPrice: "80",
    restaurantMenu: false,
    subCategory: "",
    ingredients: "bottle",
  },
  {
    id: 2322,
    image: null,
    title: "Spirits Special",
    price: "10",
    category: "DRINKS",
    servingTime: null,
    beachMenu: true,
    beachPrice: "10",
    restaurantMenu: false,
    subCategory: "",
    ingredients: "glass",
  },
  {
    id: 2323,
    image: null,
    title: "Spirits Special",
    price: "100",
    category: "DRINKS",
    servingTime: null,
    beachMenu: true,
    beachPrice: "100",
    restaurantMenu: false,
    subCategory: "",
    ingredients: "bottle",
  },
  {
    id: 2324,
    image: null,
    title: "Spirits Premium",
    price: "13",
    category: "DRINKS",
    servingTime: null,
    beachMenu: true,
    beachPrice: "13",
    restaurantMenu: false,
    subCategory: "",
    ingredients: "glass",
  },
  {
    id: 2325,
    image: null,
    title: "Spirits Premium",
    price: "130",
    category: "DRINKS",
    servingTime: null,
    beachMenu: true,
    beachPrice: "130",
    restaurantMenu: false,
    subCategory: "",
    ingredients: "bottle",
  },
  {
    id: 2327,
    image: null,
    title: "Red Bull",
    price: "6",
    category: "DRINKS",
    servingTime: null,
    beachMenu: true,
    beachPrice: "7",
    restaurantMenu: true,
    subCategory: "",
    ingredients: "250ml",
  },
  {
    id: 2328,
    image: null,
    title: "Coca cola",
    price: "5",
    category: "DRINKS",
    servingTime: null,
    beachMenu: true,
    beachPrice: "7",
    restaurantMenu: true,
    subCategory: "",
    ingredients: "",
  },
  {
    id: 2329,
    image: null,
    title: "Fanta",
    price: "5",
    category: "DRINKS",
    servingTime: null,
    beachMenu: true,
    beachPrice: "7",
    restaurantMenu: true,
    subCategory: "",
    ingredients: "",
  },
  {
    id: 2330,
    image: null,
    title: "Sprite",
    price: "5",
    category: "DRINKS",
    servingTime: null,
    beachMenu: true,
    beachPrice: "7",
    restaurantMenu: true,
    subCategory: "",
    ingredients: "",
  },
  {
    id: 2331,
    image: null,
    title: "Water",
    price: "2",
    category: "DRINKS",
    servingTime: null,
    beachMenu: false,
    beachPrice: null,
    restaurantMenu: true,
    subCategory: "",
    ingredients: "1L",
  },
  {
    id: 2332,
    image: null,
    title: "Gordon’s Space",
    price: "5",
    category: "DRINKS",
    servingTime: null,
    beachMenu: true,
    beachPrice: "7",
    restaurantMenu: true,
    subCategory: "",
    ingredients: "250ml",
  },
  {
    id: 2333,
    image: null,
    title: "Pink Soda",
    price: "5",
    category: "DRINKS",
    servingTime: null,
    beachMenu: true,
    beachPrice: "7",
    restaurantMenu: true,
    subCategory: "",
    ingredients: "",
  },
  {
    id: 2401,
    image: null,
    title: "Beer Amstel",
    price: "5",
    category: "BEER",
    servingTime: null,
    beachMenu: true,
    beachPrice: "7",
    restaurantMenu: true,
    subCategory: "",
    ingredients: "330ml",
  },
  {
    id: 2402,
    image: null,
    title: "Beer radler",
    price: "5",
    category: "BEER",
    servingTime: null,
    beachMenu: true,
    beachPrice: "7",
    restaurantMenu: true,
    subCategory: "",
    ingredients: "330ml",
  },
  {
    id: 2403,
    image: null,
    title: "Beer Heineken",
    price: "5",
    category: "BEER",
    servingTime: null,
    beachMenu: true,
    beachPrice: "7",
    restaurantMenu: true,
    subCategory: "",
    ingredients: "330ml",
  },
  {
    id: 2404,
    image: null,
    title: "Beer Fisher",
    price: "5",
    category: "BEER",
    servingTime: null,
    beachMenu: true,
    beachPrice: "7",
    restaurantMenu: true,
    subCategory: "",
    ingredients: "330ml",
  },
  {
    id: 2405,
    image: null,
    title: "Beer Erdinger",
    price: "5",
    category: "BEER",
    servingTime: null,
    beachMenu: true,
    beachPrice: "7",
    restaurantMenu: true,
    subCategory: "",
    ingredients: "330ml",
  },
  {
    id: 2406,
    image: null,
    title: "Beer Corona",
    price: "6",
    category: "BEER",
    servingTime: null,
    beachMenu: true,
    beachPrice: "7",
    restaurantMenu: true,
    subCategory: "",
    ingredients: "330ml",
  },
  {
    id: 2407,
    image: null,
    title: "Draft Beer",
    price: "5",
    category: "BEER",
    servingTime: null,
    beachMenu: true,
    beachPrice: "7",
    restaurantMenu: true,
    subCategory: "",
    ingredients: "400ml",
  },
  {
    id: 2408,
    image: null,
    title: "Beer Stella non-alcoholic",
    price: "5",
    category: "BEER",
    servingTime: null,
    beachMenu: true,
    beachPrice: "7",
    restaurantMenu: true,
    subCategory: "",
    ingredients: "bottle",
  },

];


